import React from "react";

export default function BitgetTpOverrideRuleEditor({ label, rules, setRules }) {
  const addRule = () =>
    setRules([...(rules || []), { type: "between", min: 0, max: 0, tpPct: 0 }]);

  const update = (i, key, val) => {
    const next = [...(rules || [])];
    next[i] = { ...next[i], [key]: val };
    setRules(next);
  };

  const remove = (i) => setRules((rules || []).filter((_, idx) => idx !== i));

  return (
    <div className="fb-section">
      <div className="fb-section-head">
        <div>
          <div className="fb-section-title">{label}</div>
          <div className="fb-hint" style={{ marginTop: 6 }}>
            Score-based TP rules take priority. If no score rule matches, the bot falls back to Profit target override (%).
            These TP rules do not bypass Minimum score or other entry filters.
          </div>
        </div>
        <button type="button" className="btn ghost" onClick={addRule}>
          + Add Rule
        </button>
      </div>

      {(rules?.length ?? 0) === 0 && (
        <div className="fb-hint">
          No TP override rules yet. Add one to override TP % by score band.
        </div>
      )}

      <div className="rule-grid">
        {(rules || []).map((r, i) => (
          <div key={i} className="rule-card">
            <div className="rule-row">
              <label className="rule-label" htmlFor={`bg-tp-type-${i}`}>Condition</label>
              <select
                id={`bg-tp-type-${i}`}
                value={r.type}
                onChange={(e) => update(i, "type", e.target.value)}
              >
                <option value="between">Between</option>
                <option value="above">Above</option>
                <option value="below">Below</option>
              </select>
            </div>

            {(r.type === "between" || r.type === "above") && (
              <div className="rule-row">
                <label className="rule-label" htmlFor={`bg-tp-min-${i}`}>Min</label>
                <input
                  id={`bg-tp-min-${i}`}
                  type="number"
                  inputMode="decimal"
                  placeholder="0"
                  value={r.min ?? ""}
                  onChange={(e) =>
                    update(i, "min", e.target.value === "" ? "" : Number(e.target.value))
                  }
                />
              </div>
            )}

            {(r.type === "between" || r.type === "below") && (
              <div className="rule-row">
                <label className="rule-label" htmlFor={`bg-tp-max-${i}`}>Max</label>
                <input
                  id={`bg-tp-max-${i}`}
                  type="number"
                  inputMode="decimal"
                  placeholder="0"
                  value={r.max ?? ""}
                  onChange={(e) =>
                    update(i, "max", e.target.value === "" ? "" : Number(e.target.value))
                  }
                />
              </div>
            )}

            <div className="rule-row">
              <label className="rule-label" htmlFor={`bg-tp-pct-${i}`}>TP %</label>
              <input
                id={`bg-tp-pct-${i}`}
                type="number"
                inputMode="decimal"
                min="0"
                step="0.01"
                placeholder="e.g. 4.5"
                value={r.tpPct ?? ""}
                onChange={(e) =>
                  update(i, "tpPct", e.target.value === "" ? "" : Number(e.target.value))
                }
              />
            </div>

            <div className="rule-actions">
              <button type="button" className="btn ghost small" onClick={() => remove(i)}>
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}